// _loader.js
import { getGSAP } from './_gsap.js';

let totalAssets = 0;
let loadedAssets = 0;
const minLoaderTime = 3000; // Durée minimale du loader en millisecondes (3 secondes)
let loadStartTime;

export function initLoader() {
  const gsap = getGSAP();
  loadStartTime = Date.now();
  // Ajouter la classe "is-loading" au body au début du chargement
  document.body.classList.add('is-loading');
  

  // Fonction pour mettre à jour la barre de progression
  function updateProgress() {
    const progress = (loadedAssets / totalAssets) * 100;
    gsap.to('#loader-progress', { width: `${progress}%`, duration: 0.3, ease: 'power1.out' });
    document.getElementById('loader-percentage').textContent = `${Math.round(progress)}%`;
  }

  // Fonction pour cacher le loader et afficher le contenu
  function hideLoader() {
    const currentTime = Date.now();
    const elapsedTime = currentTime - loadStartTime;
    const remainingTime = Math.max(0, minLoaderTime - elapsedTime);

    setTimeout(() => {
      gsap.to('#loader-wrapper', { 
        opacity: 0, 
        duration: 0.5, 
        onComplete: () => {
          document.getElementById('loader-wrapper').style.display = 'none';
          // Retirer la classe "is-loading" du body
          document.body.classList.remove('is-loading');
          // Déclencher un événement personnalisé pour signaler que le loader a terminé
          document.dispatchEvent(new Event('loaderFinished'));
        }
      });
    }, remainingTime);
  }

  // Compter le nombre total d'assets à charger
  totalAssets = document.images.length + 
                document.querySelectorAll('script').length + 
                document.querySelectorAll('link[rel="stylesheet"]').length;

  // S'assurer qu'il y a au moins un asset à charger pour éviter la division par zéro
  totalAssets = Math.max(totalAssets, 1);

  // Fonction pour incrémenter le compteur d'assets chargés
  function assetLoaded() {
    loadedAssets++;
    updateProgress();
    if (loadedAssets >= totalAssets) {
      hideLoader();
    }
  }

  // Écouter le chargement des images
  Array.from(document.images).forEach((img) => {
    if (img.complete) assetLoaded();
    else img.addEventListener('load', assetLoaded);
  });

  // Écouter le chargement des scripts
  Array.from(document.querySelectorAll('script')).forEach((script) => {
    script.addEventListener('load', assetLoaded);
  });

  // Écouter le chargement des feuilles de style
  Array.from(document.querySelectorAll('link[rel="stylesheet"]')).forEach((stylesheet) => {
    stylesheet.addEventListener('load', assetLoaded);
  });

  // Fallback si le chargement est trop rapide ou si certains assets ne se chargent pas
  window.addEventListener('load', hideLoader);

  // Simuler une progression minimale si le chargement est trop rapide
  let simulatedProgress = 0;
  const simulateLoading = setInterval(() => {
    simulatedProgress += 5;
    loadedAssets = Math.max(loadedAssets, Math.floor((simulatedProgress / 100) * totalAssets));
    if (simulatedProgress >= 100) {
      clearInterval(simulateLoading);
      hideLoader();
    } else {
      updateProgress();
    }
  }, 100);
}